import React, { useState } from 'react';
import Webcam from "react-webcam";
import './Button.css';
import './Age.css';
import Popup from 'reactjs-popup';


const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user"
};

function Age() {
  const [image, setImg] = useState(0);
  const [showImg, setShowImg] = React.useState(0)

  let webcam;

  if (showImg == 1) {
    webcam = <><img src={image} />
      <div class="container">
        <button class="button" onClick={() => { setShowImg(0) }}>Retake</button>
        <button class="button" onClick={() => { setShowImg(2);
        const timer = setTimeout(() => {
          setShowImg(3);
        }, 20000);
        }}>Confirm</button>
      </div>
    </>
  } else if (showImg == 0) {
    webcam = <>
            <Popup
    trigger={<button className="button"> Instructions </button>}
    modal
    nested
    defaultOpen
  >
    {close => (
      <div className="modal">
        <div className="header"> <strong> AI De-Ageifier </strong> </div>
        <div className="content">
          {' '}
          Can you remember what you looked like when you were younger? We’ve trained our AI on millions of photos of people both when they were younger and how they look now. As a result, our ML algorithm will take a picture of you through the webcam and show you what you looked like in the past, with scary accuracy!
          <br />
          <br />
        </div>
        <div className="actions">
          <button
            className="button"
            onClick={() => {
              console.log('modal closed ');
              close();
            }}
          >
            Let's Get Started!
          </button>
        </div>
      </div>
    )}
  </Popup>

    <Webcam
      audio={false}
      height={720}
      screenshotFormat="image/jpeg"
      width={1280}
      videoConstraints={videoConstraints}
    >
      {({ getScreenshot }) => (
        <button class="button"
          onClick={() => {
            setImg(getScreenshot());
            setShowImg(1);
          }}
        >
          Take Photo
        </button>
      )}
    </Webcam>
    </>
  } else if (showImg == 2) {
    webcam = <p>
    Loading...
    </p>
  } else if (showImg == 3) {
    webcam = <>
    <p>
      This was you twenty seconds younger. Feel old yet?
    </p>
    <img src={image} />
    </>

  }

  return (
    <div className="App">
      <header className="App-header">
        <p>
          Age Simulator
        </p>
        {webcam}

      </header>
    </div>
  );
}

export default Age;
